var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.106 17.888c-.254 3.239-1.153 6.111-2.445 8.255-1.548 2.57-3.563 3.96-5.622 3.96-2.058 0-4.073-1.39-5.622-3.96C9.124 24 8.226 21.127 7.97 17.888a8.272 8.272 0 0 0 16.136 0zm.014-3.582c-.233-3.318-1.141-6.263-2.46-8.45-1.548-2.57-3.563-3.959-5.622-3.959-2.058 0-4.073 1.39-5.622 3.96-1.318 2.186-2.226 5.13-2.46 8.449a8.272 8.272 0 0 1 10.518-6.147v-.014l.04.026a8.284 8.284 0 0 1 5.606 6.134zm-5.26-5.332c.205.082.407.173.604.273l1.382.896v4.831h2.743a7.693 7.693 0 0 1 .024 1.988h-2.768v5.025a7.627 7.627 0 0 1-1.819 1.097l-.168.068v-6.19H16.55v-1.988h2.309v-6zm-.386-.14a7.597 7.597 0 0 0-1.923-.381v6.137h1.924V8.833zm-3.525-.32v15.101a7.58 7.58 0 0 1-1.347-.32V8.833a7.578 7.578 0 0 1 1.346-.32zm-2.822 1v13.101a7.664 7.664 0 0 1-1.474-1.148V10.661c.441-.44.936-.825 1.474-1.147zm-3.013 3.342a7.6 7.6 0 0 0-.705 3.208 7.6 7.6 0 0 0 .705 3.208v-6.415zm7.436 10.82v-6.33h1.924v5.95a7.593 7.593 0 0 1-1.923.38zm4.68-2.024a7.614 7.614 0 0 0 2.33-4.306h-2.33v4.306zm2.294-7.062a7.617 7.617 0 0 0-2.293-4.114v4.114h2.294zM25.077 16c0 8.284-4.047 15-9.038 15-4.993 0-9.04-6.716-9.04-15s4.047-15 9.038-15c4.992 0 9.039 6.716 9.039 15z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcm);
export default __webpack_public_path__ + "static/media/ACM.56ddcf5dd06998de2d0ac768ee9e108a.svg";
export { ForwardRef as ReactComponent };